import { DAP } from "@gen/dap/v1/dap_pb";
import { Journey, Travel } from "@gen/travel/v1/common_pb";
import { useOutletContext } from "react-router";

interface ExchangeContext {
  dap: DAP;
  travel: Travel;
  journey: Journey;
}

export function useExchangeContext() {
  return useOutletContext<ExchangeContext>();
}
